<template>
  <PortalWidget v-if="hasRtb" :widget="widget">
    <template v-slot:headerContent>
      <div class="header-extra"></div>
    </template>
    <div class="rtb-dashboard p-b-30">
      <RtbExport />
      <RtbSearch />
    </div>
    <div class="row row--bs-margin rtb-stats">
      <div class="col-xs-12 m-b-15">
        <RtbStatsByPublisher class="rtb-stats__widget--alt" />
      </div>
      <div class="col-xs-12 m-b-15">
        <RtbStatsRejectionByPublisher class="rtb-stats__widget--alt" />
      </div>
    </div>
  </PortalWidget>
</template>

<script>
import { mapState } from 'vuex';
import messages from './locales';
import sharedMessages from '@/core/locales';
import PortalWidget from '@/core/components/PortalWidget.vue';
import RtbExport from './components/Export';
import RtbSearch from './components/RtbSearch';
import RtbStatsByPublisher from '@/modules/rtbStats/components/RtbStatsByPublisher';
import RtbStatsRejectionByPublisher from '@/modules/rtbStats/components/RtbStatsRejectionByPublisher';
export default {
  components: {
    PortalWidget,
    RtbExport,
    RtbSearch,
    RtbStatsByPublisher,
    RtbStatsRejectionByPublisher
  },
  data() {
    return {
      filters: {
        name: { value: '', keys: ['name'] }
      },
      widget: {
        title: this.$i18n.t('HEADER_REAL_TIME_BIDDING'),
        iconClass: 'fa fa-trophy'
      }
    }
  },
  computed: {
    ...mapState({
      flags: 'currentAccountFeatureFlags'
    }),
    hasRtb() {
      return !!this.flags.rtb;
    }
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en',
  },
};
</script>
<style lang="scss" scoped>

</style>
